import type React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, Calendar, MessageSquare, Target } from "lucide-react";

const StatCard: React.FC<{
	title: string;
	value: string | number;
	description: string;
	icon: React.ReactNode;
}> = ({ title, value, description, icon }) => (
	<Card>
		<CardHeader className="flex flex-row items-center justify-between pb-2">
			<CardTitle className="text-sm font-medium">{title}</CardTitle>
			{icon}
		</CardHeader>
		<CardContent>
			<div className="text-2xl font-bold">{value}</div>
			<p className="text-xs text-muted-foreground">{description}</p>
		</CardContent>
	</Card>
);

const DashboardPage: React.FC = () => {
	return (
		<div className="space-y-6">
			<h1 className="text-3xl font-bold">管理ダッシュボード</h1>

			<div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
				<StatCard
					title="総ユーザー数"
					value="150"
					description="先月比 +12%"
					icon={<Users className="h-4 w-4 text-muted-foreground" />}
				/>
				<StatCard
					title="イベント数"
					value="24"
					description="今月開催予定"
					icon={<Calendar className="h-4 w-4 text-muted-foreground" />}
				/>
				<StatCard
					title="アクティブチャンネル"
					value="8"
					description="過去7日間"
					icon={<MessageSquare className="h-4 w-4 text-muted-foreground" />}
				/>
				<StatCard
					title="達成済み目標"
					value="65"
					description="全体の45%"
					icon={<Target className="h-4 w-4 text-muted-foreground" />}
				/>
			</div>

			{/* 追加のダッシュボード要素をここに実装 */}
		</div>
	);
};

export default DashboardPage;
